import CreateSetupBackend from "../config/config.js";

let SetupBackend = null;

/**
 * Serviço de Cash Out (PIX Out / Transferências / Saques)
 * Utiliza os endpoints Gowd via Higher-API Gateway
 */

function create(data) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");
  const twoFactorQuery = data?.twoFactorCode
    ? `&twoFactorCode=${encodeURIComponent(data.twoFactorCode)}`
    : "";
  return SetupBackend.post(
    `/v1/baas/order-payouts?email=${email}${twoFactorQuery}`,
    data,
  );
}

/**
 * TED — transferência para conta bancária.
 *
 * ── O MESMO endpoint do PIX ──
 *
 * O que muda é o `paymentMethod` e o destino: em vez de chave, os dados bancários do
 * recebedor. O servidor recusa chave PIX junto de conta bancária, porque isso descreveria
 * dois destinos para o mesmo pagamento — e ambiguidade sobre para onde o dinheiro vai não
 * se resolve adivinhando.
 *
 * `iniciationType` não vai: ele descreve como um PIX foi iniciado, e não existe em TED.
 */
function createTed(data) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");
  const twoFactorQuery = data?.twoFactorCode
    ? `&twoFactorCode=${encodeURIComponent(data.twoFactorCode)}`
    : "";

  const payload = {
    externalId: data.externalId,
    amount: { currency: "BRL", value: data.amount },
    paymentMethod: "TED",
    receiver: {
      name: data.receiverName,
      document: {
        type: data.receiverDocumentType,
        number: data.receiverDocument,
      },
    },
    paymentData: {
      bankAccount: {
        // Só o identificador informado vai: mandar os dois, com um vazio, é recusado.
        ...(data.ispb ? { ispb: data.ispb } : { bankNumber: data.bankNumber }),
        branchNumber: data.branchNumber,
        accountNumber: data.accountNumber,
        accountType: data.accountType,
      },
    },
    description: data.description,
  };

  return SetupBackend.post(
    `/v1/baas/order-payouts?email=${email}${twoFactorQuery}`,
    payload,
  );
}

function show(data) {
  SetupBackend = CreateSetupBackend();
  const email = sessionStorage.getItem("emailUser");
  let url = `/v1/baas/accounts/statements?email=${email}`;
  if (data.startDate) {
    url += `&startDate=${data.startDate}`;
  }
  if (data.endDate) {
    url += `&endDate=${data.endDate}`;
  }

  return SetupBackend.get(url);
}

const backendServices = {
  create,
  createTed,
  show,
};

export default backendServices;
